export function getImageClickAction(action, hasGoogleIntegration) {
  if (hasGoogleIntegration) {
    return action === 'link' ? 'popup' : action;
  }

  return action;
}
